<template>
  <div class="border">
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="false"
      :itemLink="itemLink"
      :setLink="setLink"
      :fields="fields"
      :searchDisable="true"
      :openItem="false"
      @updated="$emit('updated', true)"
      @added="$emit('added', true)"
      @change="change"
      @input="change"
      @changeFunction="changeFunction"
      @deleted="$emit('deleted', true)"
      v-model="val"
    />

    <button class="btn btn-info btn-icon mt-5" @click="close">
      {{ "next_not_found" | setText("У меня другая проблема") }}
    </button>
  </div>
</template>
<script>
export default {
  name: "products",
  props: {
    id: {
      default: null,
    },
  },
  created() {
    this.itemLink = `info_projects/${this.id}/infos`;
    this.setLink = `info_projects/${this.id}/infos`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},

    close() {
      let query = Object.assign({}, this.$route.query);

      if (query["item_info_project_info"]) {
        delete query["item_info_project_info"];
      }
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  },
  data() {
    return {
      val: [],
      modalCreate: "purchase",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "partner",
          label: "Партнер",
          type: "select",
          modal: "partner",
          selectKey: "name",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_get_info",
      itemLink: "orders",
      setLink: "orders",
      columns: [
        {
          key: "name",
          title: "Название",
        },

        {
          detail: true,
        },
      ],
    };
  },
};
</script>
